<template>
  <div>
    <img :src="url" style="width: 100px;height: 50px;" @click="imgClick">
  </div>
</template>

<script>
export default {
  name: "bigImageComponent",
  data:function (){
    return{
      id: Math.floor(Math.random() * 10100)
    }
  },
  props:{
    url:String,
  },
  methods:{
    imgClick(){
      $("#imgPopupImg").attr("src",this.url)
      $("#imgPopup").modal("show");

    }
  }
}
</script>

<style scoped>

</style>